// extracted by mini-css-extract-plugin
export var avatarContainer = "_bd-0";
export var avatarTypingWave = "_bd-i";
export var gray = "_bd-f";
export var green = "_bd-c";
export var icon = "_bd-9";
export var image = "_bd-1";
export var lg = "_bd-6";
export var md = "_bd-5";
export var presenceDot = "_bd-b";
export var red = "_bd-d";
export var sm = "_bd-4";
export var status = "_bd-a";
export var typingDot = "_bd-h";
export var typingPill = "_bd-g";
export var xl = "_bd-7";
export var xs = "_bd-3";
export var xxl = "_bd-8";
export var xxs = "_bd-2";
export var yellow = "_bd-e";